module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/572a212c2e777e3a9061c97453497009.png";